export const getReferences = () => {
  const references = {
    cta: ['cta.buttons.inner_page'],
    content_columns: ['content_columns.content.cta.inner_page'],
    clickable_cards: ['cards.button.inner_page'],
    related_articles: ['articles.page'],
    content_columns_slider: ['slides'],
    copy_with_icons: ['items.icon'],
    media_tile: ['ctas.inner_page'],
  };

  const referenceKeys = Object.keys(references) as (keyof typeof references)[];
  const layoutReferences = referenceKeys.reduce(
    (previous, key) => [
      ...previous,
      ...references[key].map((innerReference) => `reference.${innerReference}`),
    ],
    [],
  );

  const nestedReferences = {
    ...references,
    layout_container: ['reference', ...layoutReferences],
  };
  return nestedReferences;
};
